export enum actionTypes {
  SET_VISIBLE_STICK_HEADER = 'SetVisibleStickHeader',
  SET_VISIBLE_STICK_BOTTOM = 'SetVisibleStickBottom',
  SET_DIMENSIONS_FEEDBACK = 'SetTopDimensionsFeedback',
  TOGGLE_LOAD_FEEDBACK = 'ToggleLoadFeedback',
  TOGGLE_SCREEN_FEEDBACK = 'ToggleScreenFeedback',
  SET_SEND_ERROR_FEEDBACK = 'SetSendErrorFeedback',
  GET_PUBLICATIONS_LIST_REQUEST = 'GetPublicationsListRequest',
  GET_PUBLICATIONS_LIST_SUCCESS = 'GetPublicationsListSuccess',
  GET_PUBLICATIONS_LIST_FAILURE = 'GetPublicationsListFailure',
  SET_GRAPHS_DATA = 'SetGraphsData',
  SET_GRAPHS_LOADING = 'SetGraphsLoading',
  TOGGLE_REGION_GRAPH = 'ToggleRegionGraph',
  TOGGLE_GRAPH_VALUES_TYPE = 'ToggleGraphValuesType',
  GET_PUBLICATION_REQUEST = 'GetPublicationRequest',
  GET_PUBLICATION_SUCCESS = 'GetPublicationSuccess',
  GET_PUBLICATION_FAILURE = 'GetPublicationFailure',
}
